import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { EmployeeService } from '../../employee-profile/employee-profile.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-employee-onboarding',
  templateUrl: './employee-onboarding.component.html',
  styleUrls: ['./employee-onboarding.component.css']
})
export class EmployeeOnboardingComponent implements OnInit {
    
  requestedComments: any;
  constructor(private _employeeService: EmployeeService, private dialog: MatDialogRef<EmployeeOnboardingComponent>, private cdRef: ChangeDetectorRef) {

  }

  competencies: any;
  subCompetencies: any;
  showComments: boolean = false;
  showAccept: boolean;
  selectedCompetency: any;
  selectedSubCompetency: any;
  selectedCompetencyId: any;
  selectedSubCompetencyId: any;
  selectedCompetencyName: any;
  selectedSubCompetencyName: any;
  assignedCompetencyId: any;
  assignedSubCompetencyId: any;
  assignedCompetencyName: any;
  assignedSubCompetencyName: any;
  employeeId: any;
  IsEmployeeRequestedForCompetency: boolean = true;
  isContentLoaded = false;
  primaryskills: any;
  secondaryskills: any;
  selectedprimaryskills: any[] = [];
  selectedsecondaryskills: any[] = [];
  concatenatedprimaryskills: string;
  concatenatedsecondaryskills: string;
  invalidcompetency: boolean = false;
  invalidsubcompetency: boolean = false;
  invalidprimaryskills: boolean = false;
  invalidsecondaryskills: boolean = false;


  ngOnInit() {
    this.employeeId = parseInt(localStorage.getItem("Id"));
    this.getCompetencies();
    this.IsEmployeeRequestedForCompetencyAndSubCompetency();
  }
  IsEmployeeRequestedForCompetencyAndSubCompetency() {
    this._employeeService.IsEmployeeRequestedForCompetencyAndSubCompetency(this.employeeId).subscribe((response) => {
      this.IsEmployeeRequestedForCompetency = response.value;
      if (this.IsEmployeeRequestedForCompetency == false) {
        this.mapEmployeeCompetencyAndSubCompetency();
        this.getprimaryskills();
      }
      this.isContentLoaded = true;
      this.cdRef.detectChanges();
    })
  }
  mapEmployeeCompetencyAndSubCompetency() {
    this._employeeService.mapEmployeeCompetencyAndSubCompetency(this.employeeId).subscribe((response) => {
      this.selectedCompetency = response.value.competencyId;
      this.assignedCompetencyId = response.value.competencyId
      this.assignedCompetencyName = response.value.competencyName;
      this.assignedSubCompetencyId = response.value.subCompetencyId;
      this.assignedSubCompetencyName = response.value.subCompetencyName;

      this.selectedSubCompetency = response.value.subCompetencyId;
      if (response.value.competencyId == null || response.value.subCompetencyId == null || response.value.subCompetencyId == 0) {
        this.showAccept = true;
      }
      else {
        this.getSubCompetencies(response.value.competencyId);
        this.showAccept = false;

      }
    })
  }

  getCompetencies() {
    this._employeeService.getCompetencies().subscribe((response) => {
      this.competencies = response.data;
    })
  }
  async getprimaryskills() {
    console.log(this.selectedCompetencyId, this.selectedSubCompetencyId);
    this._employeeService
      .getAllPrimarySkills(this.selectedCompetencyId, [this.selectedSubCompetencyId], "")
      .subscribe((result) => {
        this.primaryskills = result.data;
        this.secondaryskills = result.data;
      }
      )
  }
  getSubCompetencies(compId: any) {
    this._employeeService.getSubcompetencies(compId).subscribe((response) => {
      this.subCompetencies = response.data;
    })
  }
  onCompetencySelect(event: any) {
    //console.log(event);
    this.getSubCompetencies(event);
    this.selectedCompetencyId = event
    this.selectedCompetencyName = event.Name;
  }
  onsubCompetencySelect(event: any) {
    this.getprimaryskills();
    this.selectedCompetencyId = event;
    this.selectedCompetencyName = event.name;
  }
  updateprimaryskills(event: any) {
    this.selectedprimaryskills = event;
    this.concatenatedprimaryskills = this.selectedprimaryskills.map(pskill => pskill.name).join(', ');
    console.log(this.concatenatedprimaryskills);
    this.invalidprimaryskills = this.concatenatedprimaryskills != null && this.concatenatedprimaryskills != "" ? false : true;
    if (this.concatenatedprimaryskills != "" && this.concatenatedprimaryskills !== '' && this.concatenatedprimaryskills != undefined && this.concatenatedsecondaryskills != "" && this.concatenatedsecondaryskills !== '' && this.concatenatedsecondaryskills != undefined) {
      this.findduplicates(this.concatenatedprimaryskills, this.concatenatedsecondaryskills);
    }

  }
  updatesecondaryskills(event: any) {
    this.selectedsecondaryskills = event;
    this.concatenatedsecondaryskills = this.selectedsecondaryskills.map(pskill => pskill.name).join(', ');
    this.invalidsecondaryskills = this.concatenatedsecondaryskills != null && this.concatenatedsecondaryskills != "" ? false : true;
    if (this.concatenatedprimaryskills != "" && this.concatenatedprimaryskills !== '' && this.concatenatedprimaryskills != undefined && this.concatenatedsecondaryskills != "" && this.concatenatedsecondaryskills !== '' && this.concatenatedsecondaryskills != undefined) {
      this.findduplicates(this.concatenatedprimaryskills, this.concatenatedsecondaryskills);
    }
  }
  defer() {
    this.showComments = true;

    this.invalidcompetency = false;
    this.invalidsubcompetency = false;
    this.invalidprimaryskills = false;
    this.invalidsecondaryskills = false;
    this.cdRef.detectChanges();
  }
  findduplicates(primarySkillNames: string, secondarySkillNames: string) {
    const primaryArray = primarySkillNames.split(',').map(skill => skill.trim().toLowerCase());
    const secondaryArray = secondarySkillNames.split(',').map(skill => skill.trim().toLowerCase());

    const duplicates = primaryArray.filter(skill => secondaryArray.includes(skill));

    if (duplicates.length > 0) {
      console.log('Duplicate skills found:', duplicates);
    } else {
      console.log('No duplicate skills.');
    }
  }

  Request() {
    this.getSubCompetencies(this.selectedCompetency);
    this.selectedSubCompetencyName = this.subCompetencies.find(i => i.id == this.selectedSubCompetency).name
    this.selectedCompetencyName = this.competencies.find(i => i.id == this.selectedCompetency).name
    let requestData = {
      assignedCompetencyId: this.assignedCompetencyId,
      assignedCompetencyName: this.assignedCompetencyName,
      assignedSubCompetencyId: this.assignedSubCompetencyId,
      assignedSubCompetencyName: this.assignedSubCompetencyName,
      requestedCompetencyId: this.selectedCompetency,
      requestedCompetencyName: this.selectedCompetencyName,
      requestedSubCompetencyId: this.selectedSubCompetency,
      requestedSubCompetencyName: this.selectedSubCompetencyName,
      comments: this.requestedComments,
      employeeId: this.employeeId,
      primaryskillsupdated: this.concatenatedprimaryskills,
      secondaryskillsupdated: this.concatenatedsecondaryskills
    }

    this._employeeService.requestCompetencyAndSubCompetency(requestData).subscribe((response) => {

    })
  }

  accept() {

    if (this.assignedCompetencyId != null && this.assignedSubCompetencyId != null) {

      let requestData = {
        competencyId: this.assignedCompetencyId,
        competencyName: this.assignedCompetencyName,
        subCompetencyId: this.assignedSubCompetencyId,
        subCompetencyName: this.assignedSubCompetencyName,
        employeeId: this.employeeId

      }
      this._employeeService.confirmEmployeeCompetencyAndSubCompetency(requestData).subscribe((response) => {
        this.dialog.close('accept');
      })
    }
    else {
      this.invalidcompetency = this.assignedCompetencyId != null ? false : true;
      this.invalidsubcompetency = this.assignedSubCompetencyId != null ? false : true;
      this.invalidprimaryskills = this.concatenatedprimaryskills != null && this.concatenatedprimaryskills != "" ? false : true;
      this.invalidsecondaryskills = this.concatenatedsecondaryskills != null && this.concatenatedsecondaryskills != "" ? false : true;
    }
  }
  reloadPage(): void {
    location.reload();  // Reload the current page
  }
  submit() {

    if (this.assignedCompetencyId != null && this.assignedSubCompetencyId != null && this.concatenatedprimaryskills != null && this.concatenatedsecondaryskills != null && this.concatenatedprimaryskills != "" && this.concatenatedsecondaryskills != "") {
      this.Request();
      this.dialog.close('submit');
    }
    else {
      this.invalidcompetency = this.assignedCompetencyId != null ? false : true;
      this.invalidsubcompetency = this.assignedSubCompetencyId != null ? false : true;
      this.invalidprimaryskills = this.concatenatedprimaryskills != null && this.concatenatedprimaryskills != "" ? false : true;
      this.invalidsecondaryskills = this.concatenatedsecondaryskills != null && this.concatenatedsecondaryskills != "" ? false : true;
    }
  }

  onCancel() {

    this.invalidcompetency = false;
    this.invalidsubcompetency = false;
    this.invalidprimaryskills = false;
    this.invalidsecondaryskills = false;
    this.dialog.close();
  }
}
